import React from 'react';
import { Link } from 'react-router-dom';
import ServicesSubmenu from '../components/ServicesSubmenu';
import '../styles/Services.css';

const Services: React.FC = () => {
  return (
    <div className="services-page">
      <section className="services-hero">
        <h1>Our Services</h1>
        <p>Comprehensive Web Development Solutions for Your Business</p>
      </section>

      <div className="services-content">
        <ServicesSubmenu />
        
        <section className="services-list">
          <div className="service-item">
            <div className="service-icon">
              <i className="fas fa-code"></i>
            </div>
            <div className="service-content">
              <h2>Custom Web Development</h2>
              <p>We create tailored web solutions that perfectly match your business needs. Our expert developers use the latest technologies to build scalable and efficient websites.</p>
              <ul>
                <li>Full-stack Development</li>
                <li>Custom CMS Solutions</li>
                <li>API Development & Integration</li>
                <li>Database Design & Optimization</li>
              </ul>
              <Link to="/services/web-development" className="learn-more">
                Learn More <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">
              <i className="fas fa-mobile-alt"></i>
            </div>
            <div className="service-content">
              <h2>Responsive Web Design</h2>
              <p>Create stunning, mobile-first websites that look great on all devices. We ensure your website provides an optimal viewing experience across different screen sizes.</p>
              <ul>
                <li>Mobile-First Design</li>
                <li>Cross-Browser Compatibility</li>
                <li>Performance Optimization</li>
                <li>User Experience Design</li>
              </ul>
              <Link to="/services/responsive-design" className="learn-more">
                Learn More <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">
              <i className="fas fa-shopping-cart"></i>
            </div>
            <div className="service-content">
              <h2>E-Commerce Solutions</h2>
              <p>Build powerful online stores that drive sales and growth. We develop secure and user-friendly e-commerce platforms tailored to your business needs.</p>
              <ul>
                <li>Custom E-commerce Development</li>
                <li>Payment Gateway Integration</li>
                <li>Inventory Management Systems</li>
                <li>Security Implementation</li>
              </ul>
              <Link to="/services/ecommerce-solutions" className="learn-more">
                Learn More <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>

          <div className="service-item">
            <div className="service-icon">
              <i className="fas fa-server"></i>
            </div>
            <div className="service-content">
              <h2>Website Maintenance</h2>
              <p>Keep your website running smoothly with our comprehensive maintenance services. We handle updates, security, and performance optimization.</p>
              <ul>
                <li>Regular Updates & Backups</li>
                <li>Security Monitoring</li>
                <li>Performance Optimization</li>
                <li>Technical Support</li>
              </ul>
              <Link to="/services/web-development#maintenance" className="learn-more">
                Learn More <i className="fas fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </section>
      </div>

      <section className="technology-stack">
        <h2>Our Technology Stack</h2>
        <div className="tech-grid">
          <div className="tech-item">
            <i className="fab fa-html5"></i>
            <span>HTML5</span>
          </div>
          <div className="tech-item">
            <i className="fab fa-css3-alt"></i>
            <span>CSS3</span>
          </div>
          <div className="tech-item">
            <i className="fab fa-js"></i>
            <span>JavaScript</span>
          </div>
          <div className="tech-item">
            <i className="fab fa-react"></i>
            <span>React</span>
          </div>
          <div className="tech-item">
            <i className="fab fa-node"></i>
            <span>Node.js</span>
          </div>
          <div className="tech-item">
            <i className="fab fa-php"></i>
            <span>PHP</span>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2>Ready to Start Your Project?</h2>
        <p>Let's discuss how we can help you achieve your goals</p>
        <Link to="/contact" className="cta-button">Contact Us</Link>
      </section>
    </div>
  );
};

export default Services; 